import * as yup from 'yup'
import moment from 'moment'

export const schema = yup.object().shape({
  beforeOfficeId: yup.number().required('転勤前の事業所を入力してください'),
  afterOfficeId: yup.number().required('転勤後の事業所を入力してください'),
  relocateOn: yup
    .string()
    .required('転勤年月日を入力してください')
    .test(
      'dateFormat',
      () => '転勤年月日の入力形式が正しくありません',
      (value) => {
        if (!value) return true
        return moment(value, 'YYYY/MM/DD').isValid() && /^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/.test(value)
      }
    ),
})
